import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

interface VersionInfo {
  version: string;
  name: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api/v1';

export function useVersion() {
  return useQuery<VersionInfo>({
    queryKey: ['version'],
    queryFn: async () => {
      const response = await axios.get(`${API_URL}/health/version`);
      return response.data;
    },
    staleTime: Infinity, // Version doesn't change during session
    retry: false,
  });
}
